/** Label color: selected brand vs default reading. */
const treeTitleClass = (selected: boolean) =>
  selected ? "text-primary" : "text-foreground";

/** Non-interactive chrome (chevrons, empty state). */
const treeChromeClass = "text-muted-foreground";

/** Interactive chrome (icon buttons that darken on hover). */
const treeChromeInteractiveClass =
  "text-muted-foreground hover:text-foreground";

/** Shared size for TOC progress rings / status icons (16px). */
const treeProgressIconClass = "size-4 shrink-0";

export {
  treeTitleClass,
  treeChromeClass,
  treeChromeInteractiveClass,
  treeProgressIconClass,
};
